import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useWA, useLoad, useDebounced, PageHead, Card, Tabs, Btn, Field, Badge, Skeleton, Empty, ErrorBox, Avatar, fdt } from "../ui";

const KIND = { info: ["ℹ️ Info", "blue"], success: ["✅ Good news", "green"], warning: ["⚠️ Warning", "amber"], alert: ["🚨 Important", "red"] };
const TEMPLATES = [
  ["नया feature", "🎉 YCNP पर नया feature आया है", "अब आप … कर सकते हैं। अभी आज़माएँ!", "/"],
  ["Plan offer", "👑 Subscription पर खास offer", "सीमित समय के लिए plans पर छूट। अभी देखें।", "/subscription"],
  ["Blog लिखें", "✍️ आज एक blog लिखें", "अपने अनुभव लिखें और पाठकों तक पहुँचें। अच्छे blogs monetize भी होते हैं।", "/write"],
  ["Maintenance", "🛠️ वेबसाइट update", "कुछ समय के लिए वेबसाइट पर update चलेगा। असुविधा के लिए माफ़ी।", ""],
];

function UserPicker({ value, onChange }) {
  const { api } = useWA();
  const [q, setQ] = useState("");
  const [list, setList] = useState([]);
  const dq = useDebounced(q, 250);
  useEffect(() => {
    if (dq.trim().length < 2) return setList([]);
    api("users", { q: dq.trim(), take: 6 }).then((r) => setList(r.items)).catch(() => setList([]));
  }, [dq, api]);
  return (
    <div>
      {value.length > 0 && (
        <div className="flex flex-wrap gap-1.5 mb-2">
          {value.map((u) => (
            <span key={u.id} className="inline-flex items-center gap-1.5 pl-1 pr-1 py-0.5 rounded-full border wa-line text-[12.5px]">
              <Avatar name={u.name || u.email} image={u.image} size={20} />{u.name || u.email}
              <button type="button" onClick={() => onChange(value.filter((x) => x.id !== u.id))} className="w-5 h-5 rounded-full hover:bg-slate-500/10" aria-label="Remove"><i className="fa-solid fa-xmark text-[10px]" /></button>
            </span>
          ))}
        </div>
      )}
      <div className="relative">
        <input className="wa-input" value={q} onChange={(e) => setQ(e.target.value)} placeholder="नाम या email लिखकर user चुनें…" />
        {list.length > 0 && (
          <div className="wa-card absolute left-0 right-0 mt-1 p-1" style={{ zIndex: 20 }}>
            {list.map((u) => (
              <button key={u.id} type="button" onClick={() => { if (!value.find((x) => x.id === u.id)) onChange([...value, u]); setQ(""); setList([]); }} className="w-full flex items-center gap-2.5 px-2 py-2 rounded-lg hover:bg-slate-500/10 text-left">
                <Avatar name={u.name || u.email} image={u.image} size={28} />
                <span className="min-w-0"><span className="block text-sm font-semibold truncate">{u.name || "—"}</span><span className="block text-[11.5px] wa-muted truncate">{u.email}</span></span>
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default function Notifications() {
  const { run, confirm } = useWA();
  const [to, setTo] = useState("all");
  const [users, setUsers] = useState([]);
  const [f, setF] = useState({ title: "", body: "", link: "", kind: "info" });
  const [busy, setBusy] = useState(false);
  const [scope, setScope] = useState("");
  const { data, loading, error, reload } = useLoad("notices", { scope, take: 60 }, [scope]);
  const items = (data && data.items) || [];

  const send = async () => {
    if (to === "all" && !(await confirm({ title: "सभी users को यह message भेजें?", text: f.title, ok: "हाँ, भेजें" }))) return;
    setBusy(true);
    try {
      await run("noticeSend", { ...f, ...(to === "all" ? { to: "all" } : { userIds: users.map((u) => u.id) }) }, "Message भेज दिया गया");
      setF({ title: "", body: "", link: "", kind: "info" });
      setUsers([]);
      reload();
    } catch (e) {
      /* toast */
    }
    setBusy(false);
  };
  const del = async (n) => {
    if (!(await confirm({ title: "यह message हटाएँ?", text: "Users को अब यह नहीं दिखेगा।", danger: true }))) return;
    try {
      await run("noticeDelete", { id: n.id }, "Message हट गया");
      reload();
    } catch (e) {
      /* toast */
    }
  };

  const can = f.title.trim() && f.body.trim() && (to === "all" || users.length);

  return (
    <div>
      <PageHead icon="fa-solid fa-bullhorn" title="Send Message" subtitle="Users को वेबसाइट के 🔔 Notifications में message भेजें" />
      <div className="grid grid-cols-1 xl:grid-cols-[minmax(0,1fr)_minmax(0,1fr)] gap-5 items-start">
        <Card title="नया message" icon="fa-regular fa-paper-plane">
          <Tabs tabs={[["all", "सभी users को"], ["some", "चुने हुए users को"]]} value={to} onChange={setTo} />
          {to === "some" && <div className="mt-3"><UserPicker value={users} onChange={setUsers} /></div>}
          <div className="flex flex-wrap gap-1.5 mt-4">
            <span className="text-[12px] wa-muted mr-1 self-center">Template:</span>
            {TEMPLATES.map(([l, t, b, k]) => <button key={l} type="button" onClick={() => setF({ ...f, title: t, body: b, link: k })} className="text-[12px] px-2.5 py-1 rounded-full border wa-line hover:bg-slate-500/10">{l}</button>)}
          </div>
          <div className="space-y-3 mt-4">
            <Field label="Title" right={`${f.title.length}/120`}><input className="wa-input" maxLength={120} value={f.title} onChange={(e) => setF({ ...f, title: e.target.value })} /></Field>
            <Field label="Message" right={`${f.body.length}/2000`}><textarea rows={6} maxLength={2000} className="wa-input" value={f.body} onChange={(e) => setF({ ...f, body: e.target.value })} /></Field>
            <div className="grid grid-cols-2 gap-3">
              <Field label="Link (optional)" hint="जैसे /subscription या https://…"><input className="wa-input" value={f.link} onChange={(e) => setF({ ...f, link: e.target.value })} /></Field>
              <Field label="Type">
                <select className="wa-input" value={f.kind} onChange={(e) => setF({ ...f, kind: e.target.value })}>
                  {Object.entries(KIND).map(([k, [l]]) => <option key={k} value={k}>{l}</option>)}
                </select>
              </Field>
            </div>
          </div>
          <div className="mt-4 rounded-2xl p-4 border wa-line" style={{ background: "#07051A", color: "#fff" }}>
            <p className="text-[10.5px] uppercase tracking-widest text-white/40 mb-2">Preview — user को ऐसा दिखेगा</p>
            <div className="flex gap-3">
              <span className="w-10 h-10 rounded-xl grid place-items-center text-lg shrink-0" style={{ background: "#22C55E22" }}>📣</span>
              <div className="min-w-0">
                <p className="text-sm font-bold">{f.title || "Title"}</p>
                <p className="text-sm text-white/75 whitespace-pre-line">{f.body || "Message…"}</p>
                <p className="text-xs text-cyan-300 mt-1">{to === "all" ? "Announcement from YCNP team" : "Message from YCNP team"}</p>
              </div>
            </div>
          </div>
          <div className="flex justify-end mt-4">
            <Btn variant="primary" icon="fa-solid fa-paper-plane" loading={busy} disabled={!can} onClick={send}>{to === "all" ? "सबको भेजें" : `${users.length} users को भेजें`}</Btn>
          </div>
        </Card>

        <Card title="भेजे गए messages" icon="fa-solid fa-clock-rotate-left" actions={<Tabs tabs={[["", "सभी"], ["all", "Broadcast"], ["user", "Personal"]]} value={scope} onChange={setScope} />} pad={false}>
          <ErrorBox msg={error} retry={reload} />
          {loading && !data ? <div className="p-4"><Skeleton rows={5} h={56} /></div> : !items.length ? <Empty icon="fa-regular fa-bell" title="अभी तक कोई message नहीं भेजा" /> : (
            <ul className="max-h-[75vh] overflow-y-auto wa-scroll">
              {items.map((n) => (
                <li key={n.id} className="flex gap-3 px-5 py-3.5 border-t wa-line">
                  <div className="flex-1 min-w-0">
                    <div className="flex flex-wrap items-center gap-2">
                      <p className="font-semibold text-sm">{n.title}</p>
                      <Badge tone={(KIND[n.kind] || KIND.info)[1]}>{(KIND[n.kind] || KIND.info)[0]}</Badge>
                    </div>
                    <p className="text-[13px] wa-muted whitespace-pre-wrap mt-0.5 line-clamp-3">{n.body}</p>
                    <p className="text-[11.5px] wa-muted mt-1">
                      {n.to ? <>👤 <Link to={`/website/users?open=${n.userId}`} className="underline">{n.to.name || n.to.email}</Link></> : "📢 सभी users"} · {fdt(n.createdAt)}{n.link ? ` · ${n.link}` : ""}
                    </p>
                  </div>
                  <Btn size="sm" className="!text-rose-600 shrink-0" icon="fa-regular fa-trash-can" onClick={() => del(n)} aria-label="Delete" />
                </li>
              ))}
            </ul>
          )}
        </Card>
      </div>
    </div>
  );
}
